import { render, staticRenderFns } from "./cbc_invite.vue?vue&type=template&id=c8776ac2&scoped=true"
import script from "./cbc_invite.vue?vue&type=script&lang=js"
export * from "./cbc_invite.vue?vue&type=script&lang=js"
import style0 from "./cbc_invite.vue?vue&type=style&index=0&id=c8776ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8776ac2",
  null
  
)

export default component.exports